import { Idiomorph } from 'idiomorph';
import { TIINY_STYLE_ID } from './iframeStyles';

// Editor runtime state on elements; the saved file never carries it.
const EDITOR_ATTRIBUTES = new Set(['contenteditable', 'data-tiiny-click-handler']);

const scriptSignature = (html) =>
  [...new DOMParser().parseFromString(html, 'text/html').scripts].map((s) => s.outerHTML).join('\n');

// Only a real load runs scripts, so a page whose scripts changed must be reloaded, not morphed.
export function scriptsDiffer(oldHtml, newHtml) {
  return scriptSignature(oldHtml) !== scriptSignature(newHtml);
}

// In-place patch instead of a reload: scroll, focus and document listeners survive.
export function morphIframeDocument(iframeDoc, html) {
  const newDoc = new iframeDoc.defaultView.DOMParser().parseFromString(html, 'text/html');
  Idiomorph.morph(iframeDoc.documentElement, newDoc.documentElement, {
    head: { style: 'morph' },
    callbacks: {
      beforeNodeRemoved: (node) => node.id !== TIINY_STYLE_ID,
      beforeAttributeUpdated: (name) => !EDITOR_ATTRIBUTES.has(name)
    }
  });
}
